//  the method of operating localstorage - local storage modularly

var storage = {
  set(key, value) {
    localStorage.setItem(key, JSON.stringify(value))
  },
  get(key) {
    return localStorage.getItem(key) != 'undefined' ? JSON.parse(localStorage.getItem(key)) : undefined
  },
  getForIndex(index) {
    return localStorage.key(index)
  },
  getKeys() {
    let items = this.getAll()
    let keys = []
    for (let index = 0; index < items.length; index++) {
      keys.push(items[index].key)
    }
    return keys
  },
  getLength() {
    return localStorage.length
  },
  getSupport() {
    return (typeof (Storage) !== 'undefined')
  },
  remove(key) {
    localStorage.removeItem(key)
  },
  removeAll() {
    localStorage.clear()
  },
  getAll() {
    let len = localStorage.length 
    let arr = new Array(len)
    for (var i = 0; i < len; i++) {
      var getKey = localStorage.key(i)
      var getVal = localStorage.getItem(getKey)
      arr[i] = {
        'key': getKey,
        'val': getVal
      }
    }
    return arr
  }
}

export default storage
